import { useCallback } from 'react'
import checkMarkRedIcon from '../../../assets/images/check_mark_red.svg'
import { useAnal } from '../../../hooks'
import * as styles from './index.css'

export const Checkbox = (props: {
  state: boolean
  label?: string
  disabled?: boolean
  analytic?: {
    name: string
    params?: Record<string, string | number | boolean | undefined>
  }
  onToggle: (state: boolean) => void
}) => {
  const { logEvent } = useAnal()

  const handleChange = useCallback(() => {
    if (props.disabled) return

    if (props.analytic) {
      logEvent('ui_checkbox_click', {
        name: props.analytic.name,
        state: props.state,
        ...props.analytic.params,
      })
    }

    props.onToggle(!props.state)
  }, [props])

  return (
    <label className={styles.container}>
      <input
        type='checkbox'
        checked={props.state}
        disabled={props.disabled}
        onChange={handleChange}
        className={styles.hiddenInput}
      />
      <div
        className={styles.checkBoxContainer}
        data-disabled={props.disabled ? 'true' : 'false'}
      >
        <img
          src={checkMarkRedIcon}
          className={styles.checkIconVariants[props.state ? 'check' : 'empty']}
        />
      </div>
      {props.label ? <span className={styles.label}>{props.label}</span> : null}
    </label>
  )
}
